// extracted by mini-css-extract-plugin
export default {"formTitle":"SavedFiltersList_formTitle__0g-1T","buttonWrap":"SavedFiltersList_buttonWrap__gMEUS"};